import {store} from '../../store'
import {sortByName} from '../helpers'
import get from 'lodash/get'
import _cloneDeep from 'lodash/cloneDeep'

export function deleteCropFromStoreDevices (cropId) {
  const crop = store.getters.crops.find(crop => crop.id === cropId)
  const devicesIds = get(crop, 'devices', [])
  const devices = [...store.getters.devices]
  devicesIds.forEach(deviceId => {
    const devIndex = devices.findIndex(dev => dev.id === deviceId)
    if (devIndex >= 0) {
      devices[devIndex].campaign.crops = devices[devIndex].campaign.crops.filter(crop => crop.cropRef !== cropId)
    }
  })
  store.commit('setDevices', devices)
}

export function deleteCropFromStoreCrops (cropId) {
  const crops = store.getters.crops
  let newCrops = crops.filter(crop => crop.id !== cropId)

  store.commit('setCrops', newCrops)
}

export function deleteCropFromStoreField (cropId) {
  const crop = store.getters.crops.find(crop => crop.id === cropId)
  const fieldId = get(crop, 'field', [])
  const fields = [...store.getters.fields]
  const fieldIndex = fields.findIndex(field => field.id === fieldId)
  if (fieldIndex >= 0) {
    fields[fieldIndex].crops = fields[fieldIndex].crops.filter(crop => crop !== cropId)
  }
  store.commit('setFields', fields)
}

export function addCropToStoreDevices (cropData, cropId) {
  const devices = _cloneDeep(store.getters.devices)
  devices.forEach(device => {
    if (cropData.devices && cropData.devices.includes(device.id)) {
      const storeDeviceIndex = devices.findIndex(dev => dev.id === device.id)
      const cropDataObj = {
        ...cropData,
        cropRef: cropId
      }
      delete cropDataObj.devices
      devices[storeDeviceIndex].campaign.crops.push(cropDataObj)
    }
  })
  store.commit('setDevices', devices)
}

export function updateCropIntoStoreDevices (oldCrop, newCrop) {
  const devices = _cloneDeep(store.getters.devices)
  // remove crop from old devices and update crop into devices kept in crop
  oldCrop.devices.forEach(device => {
    const deviceIndex = devices.findIndex(dev => dev.id === device)
    if (!newCrop.devices.includes(device)) {
      devices[deviceIndex].campaign.crops = devices[deviceIndex].campaign.crops.filter(crop => crop.cropRef !== oldCrop.id)
    } else {
      const cropIndex = devices[deviceIndex].campaign.crops.findIndex(crop => crop.cropRef === oldCrop.id)
      const cropToUpdateObj = {
        oldCrop,
        cropRef: oldCrop.id
      }
      delete cropToUpdateObj.devices
      delete cropToUpdateObj.id
      devices[deviceIndex].campaign.crops[cropIndex] = cropToUpdateObj
    }
  })
  // add crop to new devices
  newCrop.devices.forEach(device => {
    if (!oldCrop.devices.includes(device)) {
      const deviceIndex = devices.findIndex(dev => dev.id === device)
      const cropToUpdateObj = {
        ...newCrop,
        cropRef: newCrop.id
      }
      delete cropToUpdateObj.devices
      delete cropToUpdateObj.id
      devices[deviceIndex].campaign.crops.push(cropToUpdateObj)
    }
  })
  store.commit('setDevices', devices)
}

export function addCropToStoreCrop (cropData, id) {
  let cropsData = store.getters.crops
  const data = {
    ...cropData
  }
  cropsData.push({
    ...data,
    id,
    sowingDate: cropData.startDate || null
  })
  cropsData = cropsData.sort(sortByName)
  store.commit('setCrops', cropsData)
}

export function addCropToStoreField (fieldId, cropId) {
  let fieldsData = store.getters.fields
  const fieldIndex = fieldsData.findIndex(field => field.id === fieldId)
  if (fieldIndex !== -1) {
    const fieldCrops = get(fieldsData[fieldIndex], 'crops', [])
    // Check if crop already exists to prevent duplicates
    if (!fieldCrops.includes(cropId)) {
      fieldCrops.push(cropId)
      fieldsData[fieldIndex].crops = fieldCrops
    }
  }
  store.commit('setFields', fieldsData)
}

export function updateCropIntoStoreCrops (cropData) {
  const crops = _cloneDeep(store.getters.crops)
  const cropIndex = crops.findIndex(crop => crop.id === cropData.id)
  crops[cropIndex] = {
    ...cropData,
    type: cropData.type.join('|')
  }
  store.commit('setCrops', crops)
}

export function updateCropIntoStoreFields (oldCrop, newCrop) {
  const fields = _cloneDeep(store.getters.fields)
  const oldFieldIndex = fields.findIndex(field => field.id === oldCrop.field)
  fields[oldFieldIndex].crops = fields[oldFieldIndex].crops.filter(crop => crop !== newCrop.id)
  const newFieldIndex = fields.findIndex(field => field.id === newCrop.field)
  fields[newFieldIndex].crops.push(newCrop.id)

  store.commit('setFields', fields)
}



// WEBPACK FOOTER //
// ./src/lib/crudOperations/storeOperations.js